import { useQuery } from "@tanstack/react-query";
import EquipmentService from "../../app/data/equipment/equipmentServices";
import { EquipmentFormModel } from "../../app/data/equipment/models";
import { QUERY_KEYS } from "../../app/data/common/queryKeys";

const equipmentService = EquipmentService.getInstance();

function normalizeUnit(value: string | null | undefined): string {
  return (value || "").trim().toUpperCase();
}

/**
 * Resolves a single equipment record by unit number via list search.
 * Search may return multiples; exact unitNumber match wins.
 */
export function useEquipmentByUnitNumber(unitNumber: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: [QUERY_KEYS.GET_EQUIPMENT_LIST, "byUnitNumber", unitNumber],
    queryFn: async (): Promise<EquipmentFormModel | null> => {
      if (!unitNumber) return null;
      const page = await equipmentService.getEquipmentList(unitNumber, 0);
      const content = page?.content || [];
      const target = normalizeUnit(unitNumber);
      const exact =
        content.find((row) => normalizeUnit(row.unitNumber) === target) || null;
      return exact;
    },
    enabled: enabled && !!unitNumber,
    staleTime: 1000 * 60 * 5,
  });
}
